module.exports = __webpack_public_path__ + "media/images/sp/stores/common/flow_3-a91f9ad2fdeca6dfc68a6721e4e15870.jpg";